<template>
    <div v-if="registration">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-6 order-lg-2">
                    <registration :registration="registration"></registration>
                    <simulations :registration="registration" :simulations="simulations"></simulations>
                </div>
                <div class="col-lg-6 order-lg-1">
                    <learners :registration="registration" :learners="learners" :group="group"></learners>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Learners from './cohort/RegistrationLearners'
    import Registration from './cohort/Registration';
    import Simulations from './cohort/Simulations';
    import Groups from './cohort/GroupsCrud';

    export default {

        components: {
            Learners, Registration, Simulations, Groups
        },

        data() {
            return {
                registration: null,
                group: null,
                learners: null,
                simulations: null,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.registration.cohort.name,
                        route: '/astral/ui/dashboard/cohorts/' + this.registration.cohort.id
                    },
                    {
                        name: this.registration.degree.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/groups/'+to.params.groupId)
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.data
                    vm.group = resp.data.included.group
                    vm.learners = resp.data.included.learners
                    vm.simulations = resp.data.included.simulations
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        }
    }
</script>
